import { useDispatch, useSelector } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { fittingReducer } from './fittingSlice';
import { userReducer } from './userSlice';
import { canvasReducer } from './canvasSlice';
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';

const logger = createLogger();
const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

const rootReducer = combineReducers({
  fitting: fittingReducer,
  user: persistedUserReducer,
  canvas: canvasReducer,
});

const initialState = {};

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }), //.concat(logger),
  devTools: false, //process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  enhancers: defaultEnhancers => [...defaultEnhancers],
});

export const useAppSelector = useSelector;
export const useAppDispatch = () => useDispatch();

export default store;
